import type { ReactNode } from "react";
import { Plus } from "lucide-react";
import {
  PayloadLink,
  SimplePayloadLink,
  type PayloadLinkProps,
} from "@/components/shared/PayloadLink";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface CTAButtonLinkProps
  extends Pick<
    PayloadLinkProps,
    "type" | "page" | "url" | "phone" | "email" | "newTab" | "prefetch" | "onClick"
  > {
  label: ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}

export function CTAButtonLink({
  label,
  href,
  type,
  page,
  url,
  phone,
  email,
  newTab,
  prefetch,
  onClick,
  className,
  fullWidth = false,
}: CTAButtonLinkProps) {
  const content = (
    <>
      <span>{label}</span>
      <Plus
        className="size-[18px] shrink-0 transition-transform duration-300 group-hover:rotate-90"
        aria-hidden="true"
      />
    </>
  );

  const buttonClassName = cn(
    "group font-medium",
    fullWidth && "w-full justify-between"
  );

  if (href) {
    return (
      <Button asChild variant="cta" size="cta" className={cn(buttonClassName, className)}>
        <SimplePayloadLink href={href} newTab={!!newTab} prefetch={prefetch} onClick={onClick}>
          {content}
        </SimplePayloadLink>
      </Button>
    );
  }

  return (
    <Button asChild variant="cta" size="cta" className={cn(buttonClassName, className)}>
      <PayloadLink
        type={type}
        page={page}
        url={url}
        phone={phone}
        email={email}
        newTab={newTab}
        prefetch={prefetch}
        onClick={onClick}
      >
        {content}
      </PayloadLink>
    </Button>
  );
}
